(function(){
  var PAGE = 'free-samples-for-your-company';
  if (window.location.pathname.indexOf(PAGE) === -1) return;
  
  function fireLead(reason){
    try{
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', {
          content_name: 'Free Samples For Your Company',
          content_category: 'B2B Lead Form',
          source: reason
        });
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'meta_lead_fired',
          form_name: 'free-samples-contact-form',
          source: reason,
          currency: 'CAD'
        });
      }
      if (typeof gtag === 'function') {
        gtag('event', 'generate_lead', {
          event_category: 'engagement',
          event_label: 'free-samples-' + reason
        });
      }
      console.log('[Meta Lead] Lead event fired (reason=' + reason + ')');
    }catch(e){
      console.error('[Meta Lead] error', e);
    }
  }

  var fired = false;
  function once(reason){
    if (fired) return;
    fired = true;
    fireLead(reason);
    setTimeout(function(){ fired = false; }, 30000);
  }

  // STRATEGY 1: Detect success message on page load (post-submit reload)
  function checkSuccessOnLoad(){
    var successEl = document.querySelector('[class*="ai-contact-form__success"]');
    if (successEl && successEl.textContent && successEl.textContent.trim().length > 0) {
      console.log('[Meta Lead] Success message detected on page load');
      once('post_submit_reload');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkSuccessOnLoad);
  } else {
    checkSuccessOnLoad();
  }

  // STRATEGY 2: Listen for click on submit button (fires BEFORE navigation)
  document.addEventListener('click', function(e){
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('button[type="submit"]');
    if (!btn) return;
    // Check the button is inside our contact form (id=contact_form OR class ai-contact-form*)
    var form = btn.closest('form');
    if (!form) return;
    var isOurForm = (form.id === 'contact_form') ||
                    (form.action && form.action.indexOf('/contact') !== -1) ||
                    !!btn.closest('[class*="ai-contact-form"]') ||
                    !!btn.closest('.globo-formbuilder');
    if (isOurForm) {
      console.log('[Meta Lead] Submit button click detected on contact-style form');
      once('button_click');
    }
  }, true);

  // STRATEGY 3: Listen for form submit event (fallback)
  document.addEventListener('submit', function(e){
    if (!e.target) return;
    var form = e.target;
    var isOurForm = (form.id === 'contact_form') ||
                    (form.action && form.action.indexOf('/contact') !== -1) ||
                    !!(form.closest && form.closest('[class*="ai-contact-form"]')) ||
                    !!(form.closest && form.closest('.globo-formbuilder'));
    if (isOurForm) {
      console.log('[Meta Lead] form submit event detected');
      once('form_submit');
    }
  }, true);

  // STRATEGY 4: MutationObserver for dynamically-added success message (AJAX submit case)
  if (typeof MutationObserver === 'function') {
    var obs = new MutationObserver(function(mutations){
      for (var i=0; i<mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes) continue;
        for (var j=0; j<m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          var classMatch = n.className && typeof n.className === 'string' && n.className.indexOf('ai-contact-form__success') !== -1;
          var hasSuccessChild = n.querySelector && n.querySelector('[class*="ai-contact-form__success"]');
          if (classMatch || hasSuccessChild) {
            console.log('[Meta Lead] Success element appeared via mutation');
            once('mutation_success');
            return;
          }
        }
      }
    });
    function startObs(){
      if (document.body) obs.observe(document.body, {childList: true, subtree: true});
    }
    if (document.body) startObs();
    else document.addEventListener('DOMContentLoaded', startObs);
  }

  console.log('[Meta Lead] tracker initialized v2 (4 strategies)');
})();
